import * as React from 'react';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LineVerticalIcon} from '../icon/svg/line-vertical-icon';

import styles from './stage-indicator.module.css';

type Props = {
    currentStage: number; // 1-indexed position of the current stage,
    numStages: number;
    customColor?: string;
    height?: number;
};

export function StageIndicator(props: Props) {
    const iconArray = buildIconArray(
        props.currentStage,
        props.numStages,
        props.customColor,
        props.height
    );

    return <div className={styles.container}>{iconArray}</div>;
}

function buildIconArray(
    currentStage: number,
    numStages: number,
    customColor?: string | null,
    height?: number | null
): React.ReactNode[] {
    // @ts-expect-error
    return [...Array(numStages).keys()].map((position) => {
        // This loop is zero-indexed, so can test if index is less-than
        // current stage’s position (instead of equal-or-less-than)
        const isActive = position < currentStage;
        const iconStyle = isActive ? styles.active : styles.inactive;

        let color;
        if (customColor) {
            color = isActive ? customColor : colors.offWhiteDk;
        }

        return (
            <span key={position} style={{color}} className={iconStyle}>
                <LineVerticalIcon height={height ? height : 14} width={7} wrapWithDiv={false} />
            </span>
        );
    });
}
